import Extend from 'flarum/common/extenders';
import User from 'flarum/common/models/User';

// noinspection JSUnusedGlobalSymbols
export default [new Extend.Model(User).attribute('isLinkedToOidcProvider')];